import React, { useEffect, useState } from 'react';
import {
  Container,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Box,
  Button,
  IconButton,
} from '@mui/material';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import SuperAdminLayout from '../../../layouts/SuperAdminLayout';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  MenuItem,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import api from '../../../utils/api';

const ProductList = () => {
  const [products, setProducts] = useState([]);
  const navigate = useNavigate();
  const [editOpen, setEditOpen] = useState(false);
  const [editProduct, setEditProduct] = useState(null);
  const [units, setUnits] = useState([]);

  const user = JSON.parse(localStorage.getItem('user'));
  const fetchProducts = async () => {
    try {
      const res = await api.get(`/api/products/get-all/${user.id}`);
      setProducts(res.data);
    } catch (err) {
      console.error('Failed to fetch products', err);
    }
  };

  const fetchUnits = async () => {
    try {
      const user = JSON.parse(localStorage.getItem('user'));
      const res = await api.get(`/api/units/get-all/${user.id}`);
      setUnits(res.data);
    } catch (err) {
      console.error('Failed to fetch units:', err);
    }
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this product?'))
      return;
    try {
      await api.delete(`/api/products/delete/${id}`);
      fetchProducts(); // refresh product list
    } catch (err) {
      console.error('Failed to delete product:', err);
      alert('Failed to delete');
    }
  };

  return (
    <SuperAdminLayout>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={3}
        mt={4}
      >
        <Typography variant="h5">Product List</Typography>
        <Button
          variant="contained"
          onClick={() => navigate('/super-admin/product/create')}
        >
          Create Product
        </Button>
      </Box>
      <Dialog open={editOpen} onClose={() => setEditOpen(false)} fullWidth>
        <DialogTitle>Edit Product</DialogTitle>
        <DialogContent
          sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}
        >
          <TextField
            label="Product Name"
            value={editProduct?.productName || ''}
            onChange={(e) =>
              setEditProduct({ ...editProduct, productName: e.target.value })
            }
          />
          <TextField
            label="Opening Quantity"
            type="number"
            value={editProduct?.openingQuantity || ''}
            onChange={(e) =>
              setEditProduct({
                ...editProduct,
                openingQuantity: e.target.value,
              })
            }
          />
          <TextField
            label="Rate"
            type="number"
            value={editProduct?.purchaseRate || ''}
            onChange={(e) =>
              setEditProduct({ ...editProduct, purchaseRate: e.target.value })
            }
          />

          {/* New fields */}
          <TextField
            select
            label="Primary Unit"
            value={editProduct?.primaryUnit || ''}
            onChange={(e) =>
              setEditProduct({ ...editProduct, primaryUnit: e.target.value })
            }
          >
            {units.map((u) => (
              <MenuItem key={u._id} value={u.name}>
                {u.name}
              </MenuItem>
            ))}
          </TextField>

          <TextField
            select
            label="Secondary Unit"
            value={editProduct?.secondaryUnit || ''}
            onChange={(e) =>
              setEditProduct({ ...editProduct, secondaryUnit: e.target.value })
            }
          >
            {units.map((u) => (
              <MenuItem key={u._id} value={u.name}>
                {u.name}
              </MenuItem>
            ))}
          </TextField>

          <TextField
            label="Secondary Quantity"
            type="number"
            value={editProduct?.secondaryQuantity || ''}
            onChange={(e) =>
              setEditProduct({
                ...editProduct,
                secondaryQuantity: e.target.value,
              })
            }
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setEditOpen(false)}>Cancel</Button>
          <Button
            variant="contained"
            onClick={async () => {
              try {
                await axios.put(
                  `http://localhost:5000/api/products/update/${editProduct._id}`,
                  editProduct
                );
                alert('Product updated!');
                setEditOpen(false);
                fetchProducts(); // refetch list
              } catch (err) {
                alert('Update failed!');
              }
            }}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
      <Container fullWidth maxWidth="screen">
        <Paper>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Product Name</TableCell>
                <TableCell>Opening Qty</TableCell>
                <TableCell>Purchase Rate</TableCell>
                <TableCell>Primary Unit</TableCell>
                <TableCell>Secondary Unit</TableCell>
                <TableCell>Secondary Qty</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {products.map((p) => (
                <TableRow key={p._id}>
                  <TableCell
                    onClick={() => {
                      setEditProduct(p);
                      fetchUnits();
                      setEditOpen(true);
                    }}
                  >
                    {p.productName}
                  </TableCell>
                  <TableCell>{p.openingQuantity}</TableCell>
                  <TableCell>{p.purchaseRate}</TableCell>
                  <TableCell>{p.primaryUnit}</TableCell>
                  <TableCell>{p.secondaryUnit}</TableCell>
                  <TableCell>{p.secondaryQuantity}</TableCell>
                  <TableCell>
                    <IconButton onClick={() => handleDelete(p._id)}>
                      <DeleteIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Paper>
      </Container>
    </SuperAdminLayout>
  );
};

export default ProductList;
